/* src/app/order/pages/orders/orders.component.scss */
.blueHover:hover {
  background: #3b6ea5;
  color: white;
}
.purpleHover:hover {
  background: #7c5fa6;
  color: white;
}
.greenHover:hover {
  background: #4c9a6a;
  color: white;
}
.redHover:hover {
  background: #c0504d;
  color: white;
}
/*# sourceMappingURL=orders.component.css.map */
